/* eslint-disable import/prefer-default-export */
import { OPERATIVE_SYSTEM_TYPES } from '../../products/constants';
import api from '../../REST/api';
import { isProduction } from '../../utils/env';
import { campaignLineStatuses } from '../constants';

const CCPSystem = OPERATIVE_SYSTEM_TYPES.ccp.system;
const CFSystem = OPERATIVE_SYSTEM_TYPES.creativeFactory.system;
const ZMSAMSystem = OPERATIVE_SYSTEM_TYPES.zmsAm.system;

// Delete after draft campaign flag is deleted
function getPushedLines(transformedCampaign, campaignLinesById) {
  const cfLines = [];
  const ccpLines = [];
  const zmsAmLines = [];
  transformedCampaign.campaignLineIds.forEach(id => {
    const line = campaignLinesById[id];
    const operativeSystem = line.product?.operativeSystem;
    if (line.status !== campaignLineStatuses.PUSHED) {
      return;
    }
    if (operativeSystem === CCPSystem) {
      ccpLines.push(line);
    } else if (operativeSystem === CFSystem) {
      cfLines.push(line);
    } else if (operativeSystem === ZMSAMSystem) {
      zmsAmLines.push(line);
    }
  });

  return { ccpLines, cfLines, zmsAmLines };
}

function getPushedLinesDC(transformedCampaign, campaignLinesById) {
  const cfLines = [];

  transformedCampaign.campaignLineIds.forEach(id => {
    const line = campaignLinesById[id];
    const operativeSystem = line.product?.operativeSystem;
    if (line.status !== campaignLineStatuses.PUSHED) {
      return;
    }
    if (operativeSystem === CFSystem) {
      cfLines.push(line);
    }
  });

  return { cfLines };
}

// Delete after draft campaign flag is deleted
async function getLink(config, campaignId, lines, getMappings) {
  if (!lines.length) {
    return '';
  }
  const mappings = getMappings ? await getMappings(campaignId) : [];
  if (!mappings.length && config.system !== 'zms_am') {
    return '';
  }

  const linkGenerator = isProduction() ? 'productionLink' : 'stagingLink';
  if (config.system === 'zms_am') {
    return config[linkGenerator]({ campaignId });
  }
  return config[linkGenerator](mappings[0]);
}

async function getLinkDC(config, campaignId, lines = [], getMappings) {
  if (!lines?.length) return '';

  const linkGenerator = isProduction() ? 'productionLink' : 'stagingLink';
  if (!getMappings) return '';
  const mappings = await getMappings(campaignId);
  const mapping = mappings?.[0];

  return mapping ? config[linkGenerator](mapping) : '';
}

// Delete after draft campaign flag is deleted
export async function getPushLinks(transformedCampaign, campaignLinesById) {
  const { ccpLines, cfLines, zmsAmLines } = getPushedLines(
    transformedCampaign,
    campaignLinesById,
  );
  const campaignId = transformedCampaign.id;

  return Promise.all([
    getLink(
      OPERATIVE_SYSTEM_TYPES.creativeFactory,
      campaignId,
      cfLines,
      api.getCFMappings,
    ),
    getLink(
      OPERATIVE_SYSTEM_TYPES.ccp,
      campaignId,
      ccpLines,
      api.getCCPMappings,
    ),
    getLink(OPERATIVE_SYSTEM_TYPES.zmsAm, campaignId, zmsAmLines),
  ]).then(([cfLink, ccpLink, zmsAmLink]) => ({
    [CFSystem]: cfLink,
    [CCPSystem]: ccpLink,
    [ZMSAMSystem]: zmsAmLink,
  }));
}

export async function getPushLinksDC(transformedCampaign, campaignLinesById) {
  const { cfLines } = getPushedLinesDC(transformedCampaign, campaignLinesById);
  const campaignId = transformedCampaign.id;

  return Promise.all([
    getLinkDC(
      OPERATIVE_SYSTEM_TYPES.creativeFactory,
      campaignId,
      cfLines,
      api.getCFMappings,
    ),
  ]).then(([cfLink]) => ({
    [CFSystem]: cfLink,
  }));
}
